import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useParams, useNavigate } from "react-router-dom";

import { GetSingleStaffMenu, reset } from "../../../features/StaffMenuSlice";

import {
  Card,
  Button,
  Form,
  Col,
  Row,
} from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronCircleLeft,
  faPencilAlt,
} from "@fortawesome/free-solid-svg-icons";

import AdminLayout from "../../../layout/admin";
import { Header } from "../../../components/admin";

import {
  hideLoadingDialog,
  showAlertDialog,
  showFailedDialog,
  showLoadingDialog,
  showSuccessDialog,
} from "../../../helpers/dialog.helper";

import BASE_URL from "../../../api";
import Select from 'react-select';
import { listStaffMenu } from "../../../helpers/helper";

const FormStaffMenuPage = () => {
  const [newData, setNewData] = useState({
    nama: "",
    menus: "",
  });

  const dispatch = useDispatch();
  const { data, isLoading, isError } = useSelector((state) => state.staffMenu);

  const param = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const token = localStorage.getItem("token");

  useEffect(() => {
    dispatch(reset());

    // fetch data.
    if (id) {
      fetchData();
    }
  }, [id, dispatch, token]);

  function fetchData() {
    dispatch(reset());
    dispatch(GetSingleStaffMenu({ id, token }));
  }

  useEffect(() => {
    setNewData({
      nama: data?.data?.nama,
      menus: data?.data?.menus,
    });
  }, [data]);

  const handleSubmit = (e) => {
    e.preventDefault();
    showAlertDialog({
      title: id ? "Update?" : "Simpan?",
      msg: `apakah anda yakin ingin ${
        id ? "mengupdate" : "menyimpan"
      } data ini?`,
      confirmButtonText: id ? "Update" : "Simpan",
      onConfirm: async () => {
        showLoadingDialog();
        try {
          let response;
          if (id) {
            response = await axios.put(
              `${BASE_URL}master/staff_menu/${id}`,
              {
                nama: newData.nama,
                menus: JSON.stringify(newData.menus),
              },
              {
                headers: {
                  Authorization: token,
                },
              }
            );
          } else {
            response = await axios.post(
              `${BASE_URL}master/staff_menu`,
              {
                nama: newData.nama,
                menus: JSON.stringify(newData.menus),
              },
              {
                headers: {
                  Authorization: token,
                },
              }
            );
          }
          console.log("RESPONSE : ", response);
          hideLoadingDialog();
          showSuccessDialog({
            title: "Berhasil!",
            msg: "Berhasil menyimpan data!",
          });
          navigate("/master/staff-menu/list");
        } catch (error) {
          console.log("ERROR", error);
          hideLoadingDialog();
          showFailedDialog({
            title: "Oops!",
            msg: error?.response?.data?.message || "Gagal menyimpan data!",
          });
        }
      },
    });
  };

  return (
    <AdminLayout>
      {param.pathname.split("/")[3] === "view" ? (
        <>
          <Header
            title="Detail Staff Menu"
          >
            <Button
              variant="outline-primary"
              size="sm"
              href={`/master/staff-menu/edit/${id}`}
            >
              <FontAwesomeIcon icon={faPencilAlt} className="me-2" />
              Edit
            </Button>
          </Header>
        </>
      ) : param.pathname.split("/")[3] === "add" ? (
        <>
          <Header
            title="Tambah Staff Menu"
          >
            <Button
              variant="outline-primary"
              size="sm"
              href={`/master/staff-menu/list`}
            >
              <FontAwesomeIcon icon={faChevronCircleLeft} className="me-2" />
              Kembali
            </Button>
          </Header>
        </>
      ) : param.pathname.split("/")[3] === "edit" ? (
        <>
          <Header
            title="Edit Staff Menu"
          >
            <Button
              variant="outline-primary"
              size="sm"
              href={`/master/staff-menu/list`}
            >
              <FontAwesomeIcon icon={faChevronCircleLeft} className="me-2" />
              Kembali
            </Button>
          </Header>
        </>
      ) : null}
      <Card border="light" className="shadow-sm mb-4">
        <FormPage
          id={id}
          newData={newData}
          setNewData={setNewData}
          isLoading={isLoading}
          isLocked={param.pathname.split("/")[3] === "view" || isLoading}
          handleSubmit={handleSubmit}
        />
      </Card>
    </AdminLayout>
  );
};

const FormPage = ({
  newData,
  setNewData,
  id,
  isLocked = false,
  isLoading = false,
  handleSubmit,
}) => {
  return (
    <Card.Body>
      {isLoading ? (
        <p>Loading...</p>
      ) : (
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={12} className="mb-3">
              <Form.Group id="nama_menu">
                <Form.Label>Nama</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Nama"
                  name="nama_menu"
                  disabled={isLocked}
                  value={newData.nama || ""}
                  onChange={(e) =>
                    setNewData({ ...newData, nama: e.target.value })
                  }
                />
              </Form.Group>
            </Col>
            <Col md={12} className="mb-3">
              <Form.Group id="groupBy">
                <Form.Label>Menu Untuk Staff</Form.Label>
                <Select
                  options={listStaffMenu}
                  placeholder="Pilih Menu"
                  isClearable={true}
                  value={listStaffMenu.filter(e => newData.menus?.includes(e.value))}
                  isMulti
                  isDisabled={isLocked}
                  onChange={(e) => {
                    setNewData({ ...newData, menus: e.map(e => e.value) })
                  }}
                  required
                />
              </Form.Group>
            </Col>
          </Row>
          <div>
            {!isLocked ? (
              <Button type="submit">{id ? "Update" : "Simpan"}</Button>
            ) : null}
          </div>
        </Form>
      )}
    </Card.Body>
  );
};

export default FormStaffMenuPage;
